import { exists } from '@/api'

export interface NewArrivalNoticeKeyword {
  id: number
  keyword: string
}

export function NewArrivalNoticeKeywordFromJSON(
  json: any
): NewArrivalNoticeKeyword {
  return {
    id: json.id,
    keyword: exists(json, 'keyword') ? json.keyword : ''
  }
}
